module.exports = __webpack_public_path__ + "img/yuehan.2e68629c.jpeg";